import { Navigate } from 'react-router-dom';
import { useOptionalAuth } from '../hooks/useOptionalAuth';

export default function Callback() {
  const auth = useOptionalAuth();

  // No auth provider = no realm configured, redirect to login
  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-sunken">
        <div className="text-center">
          {/* border-primary-600 kept literal: a spinner ring is a non-text UI
              indicator (WCAG 1.4.11, 3:1) — same precedent as the identical
              spinner in FieldTools/ReadingPage.tsx, left unchanged there too. */}
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-content-muted">Completing sign in...</p>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-sunken">
        <div className="text-center max-w-md p-6">
          <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900 flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-content mb-2">Authentication Error</h2>
          <p className="text-content-muted mb-4">{auth.error.message}</p>
          <a
            href="/login"
            className="inline-block px-4 py-2 bg-accent text-accent-fg rounded-lg hover:opacity-90 transition-colors"
          >
            Try again
          </a>
        </div>
      </div>
    );
  }

  // Successfully authenticated, redirect to dashboard
  return <Navigate to="/" replace />;
}
